import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../../../../service";
import { IErrorResponse } from "../../../../../../../types";
import { IWorkloadStdCreate, IWorkloadStdPayload } from "../types";
import {
    deletedRestoreWorkloadStd,
    deleteWorkloadStd,
    setWorkloadStd,
    setWorkloadStdRestore,
    updateWorkloadStd,
} from "./workloadStdSlice";

const CreateWorkloadStd = createAsyncThunk(
    "create/workload/standards",
    async (payload: IWorkloadStdCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/workload-coefficients", payload);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetWorkloadStd = createAsyncThunk("get/workload/standards", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get("/workload-coefficients");

        dispatch(setWorkloadStd(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const EditWorkloadStd = createAsyncThunk(
    "edit/workload/standards",
    async (data: IWorkloadStdPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/workload-coefficients/${data.id}`, data);
            dispatch(updateWorkloadStd(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteWorkloadStd = createAsyncThunk(
    "delete/workload/standards",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.delete(`/workload-coefficients/${id}`);
            dispatch(deleteWorkloadStd(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteWorkloadStd = createAsyncThunk(
    "get/delete/workload/standards",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.get(`/workload-coefficients/deleted-items`);
            dispatch(setWorkloadStdRestore(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const RestoreDeleteWorkloadStd = createAsyncThunk(
    "restore/delete/workload/standards",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/workload-coefficients/restore/${id}`);

            dispatch(deletedRestoreWorkloadStd(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    CreateWorkloadStd,
    GetWorkloadStd,
    EditWorkloadStd,
    DeleteWorkloadStd,
    GetDeleteWorkloadStd,
    RestoreDeleteWorkloadStd,
};
